import { BaseModel, RecursivePartial, SM } from "@models/base";

export class VzParamOldConstraints extends BaseModel {
    min?: number;
    max?: number;
    required?: boolean;
    regexp?: string;
    regexpClear?: string;
    unique?: '*' | string[];  // for Arrays, members must be unique, for Object[] - array of field ids can be specified or '*' for all fields

    errors?: { [id: string]: string };

    _regexp?: RegExp;
    _regexpClear?: RegExp;

    constructor(json?: RecursivePartial<VzParamOldConstraints>) {
        super(json);
        this.parseParamConstraints(json || {});
    }

    parse(json: RecursivePartial<VzParamOldConstraints>): VzParamOldConstraints {
        super.parse(json);
        this.parseParamConstraints(json);
        return this;
    }

    private parseParamConstraints(json: RecursivePartial<VzParamOldConstraints>): void {
        VzParamOldConstraints.assignFields<VzParamOldConstraints>(this, json, [
            'min',
            'max',
            'required',
            'errors',
            'regexp',
            'regexpClear',
            'unique'
        ]);
        if (this.regexp) {
            try {
                this._regexp = new RegExp(this.regexp);
            }
            catch(_) {}
        }
        if (this.regexpClear) {
            try {
                this._regexpClear = new RegExp(this.regexpClear, 'g');
            }
            catch(_) {}
        }
    }
}

export const OLD_DEFAULT_CONSTRAINTS_ERRORS: SM<string> = {
    required: 'Обязательный параметр',
    min: 'Значение меньше допустимого',
    max: 'Значение больше допустимого',
    regexp: 'Некорректный формат значения',
    unique: 'Такое значение уже задано'
}

export const OLD_DEFAULT_CONSTRAINT_ERROR = 'Ошибка заполнения';
